<template>
  <div class='jumbotron text-center'>
    <h2 class="display-4">Middle School Talent Show</h2>
    <h4>Nashua, New Hampshire</h4>
  </div>
</template>

<script>
export default {
  name: 'HeaderPage',
  data: function(){
    return {

    }
  },
  methods:{

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
